// useCountUp — animierte Zahl (Makeover-Design-Layer 2026-07).
// Läuft am ZENTRALEN Ticker (lib/motion/ticker.ts) statt eigenem rAF —
// K-INTEGRATION §3 / Masterplan §7: EINE rAF-Loop fürs ganze Cockpit.
// Respektiert prefers-reduced-motion (dann sofortiger Endwert, kein Ticker).

import { useEffect, useRef, useState } from "react";

import { subscribe } from "../lib/motion/ticker";

export function useCountUp(target: number | null, durationMs = 900): number | null {
  const [value, setValue] = useState<number | null>(target);
  const fromRef = useRef<number>(0);

  useEffect(() => {
    if (target == null) {
      setValue(null);
      return;
    }
    const reduced =
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setValue(target);
      fromRef.current = target;
      return;
    }
    const from = fromRef.current;
    const start = performance.now();
    let unsub = () => {};
    unsub = subscribe((now) => {
      const t = Math.min(1, (now - start) / durationMs);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out-cubic
      setValue(from + (target - from) * eased);
      if (t >= 1) {
        fromRef.current = target;
        unsub();
      }
    });
    return () => unsub();
  }, [target, durationMs]);

  return value;
}

const EUR_FMT = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

/** Ganzzahl-EUR-Format fuer animierte Werte (Cents flackern beim Zaehlen). */
export function formatEurRound(value: number | null): string {
  if (value == null) return "—";
  return EUR_FMT.format(Math.round(value));
}
